export default "__VITE_ASSET__gqPCnBpG__"